








import { Component, mixins } from '@niknevis/vue-modules'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'
import AdminContentManagerSearch from '@/modules/user/components/admin/AdminContentManagerSearch.vue'

@Component({
  components: {
    AdminContentManagerSearch
  }
})
export default class AdminContentManagerSearchFilter extends mixins(FilterEntitySearchMixin) {
}
